<template>
  <ion-grid id="calendar-grid-swiper" class="calendar-grid-swiper">
    <ion-row class="row row--header">
      <ion-col class="cell cell--header">Sun</ion-col>
      <ion-col class="cell cell--header">Mon</ion-col>
      <ion-col class="cell cell--header">Tue</ion-col>
      <ion-col class="cell cell--header">Wed</ion-col>
      <ion-col class="cell cell--header">Thu</ion-col>
      <ion-col class="cell cell--header">Fri</ion-col>
      <ion-col class="cell cell--header">Sat</ion-col>
    </ion-row>
    <template v-if="calendarPages">
      <ion-row
        v-for="(row, rowIndex) in calendarPages"
        :key="rowIndex"
        size="auto"
        class="row"
      >
        <template v-if="rowIndex === 0 && row.length < 7">
          <ion-col
            v-for="(col, colIndex) in calendarDateList.before[
              calendarDateList.before.length - 1
            ]"
            :key="colIndex"
            class="cell cell--inactive"
            @click="setCurrentMonthPrev()"
          >
            {{ col }}
          </ion-col>
        </template>
        <ion-col
          v-for="(col, colIndex) in row"
          :key="colIndex"
          class="cell"
          @click="clickCalendarPage(col.date)"
        >
          {{ col.date.date() }}
          <span v-if="!loading && col" class="cell-price">
            {{ Number(col.totalPrice).toLocaleString() }}
          </span>
        </ion-col>
        <template v-if="rowIndex !== 0 && row.length < 7">
          <ion-col
            v-for="(col, colIndex) in calendarDateList.after[0]"
            :key="colIndex"
            class="cell cell--inactive"
            @click="setCurrentMonthNext()"
          >
            {{ col }}
          </ion-col>
        </template>
      </ion-row>
      <ion-row v-if="calendarPages.length === 5" size="auto" class="row">
        <ion-col
          v-for="(col, colIndex) in calendarPages[4].length === 7
            ? calendarDateList.after[0]
            : calendarDateList.after[1]"
          :key="colIndex"
          class="cell cell--inactive"
          @click="setCurrentMonthNext()"
        >
          {{ col }}
        </ion-col>
      </ion-row>
    </template>
    <template v-else>
      <ion-row v-for="rowIndex in 6" :key="rowIndex" size="auto" class="row">
        <ion-col v-for="colIndex in 7" :key="colIndex" class="cell"> </ion-col>
      </ion-row>
    </template>
  </ion-grid>
  <ion-buttons>
    <ion-button expand="block" shape="round" @click="setCurrentMonthPrev()">
      <ion-icon slot="start" :icon="caretBackOutline" />前の月
    </ion-button>
    <ion-button
      expand="block"
      shape="round"
      :disabled="isCurrentMonthToday"
      @click="setCurrentMonthCurrent()"
    >
      今月
    </ion-button>
    <ion-button expand="block" shape="round" @click="setCurrentMonthNext()">
      <ion-icon slot="end" :icon="caretForwardOutline" />次の月
    </ion-button>
  </ion-buttons>
</template>

<script lang="ts">
import { createGesture } from '@ionic/core'
import {
  IonCol,
  IonGrid,
  IonRow,
  IonButtons,
  IonButton,
  IonIcon,
  GestureDetail,
} from '@ionic/vue'
import { caretForwardOutline, caretBackOutline } from 'ionicons/icons'
import { onMounted, defineComponent, PropType, ref } from 'vue'
import { Dayjs } from 'dayjs'
import { useCalendarBaseModule } from '@/provider/CalendarBaseModule'

export default defineComponent({
  components: {
    IonCol,
    IonGrid,
    IonRow,
    IonButtons,
    IonButton,
    IonIcon,
  },
  props: {
    setModalDate: {
      type: Function as PropType<(date: Dayjs | null) => void>,
      required: true,
    },
  },
  setup(props) {
    const movingHandler = ref(false)
    const {
      isCurrentMonthToday,
      setCurrentMonthPrev,
      setCurrentMonthCurrent,
      setCurrentMonthNext,
      loading,
      calendarPages,
      calendarDateList,
    } = useCalendarBaseModule()
    onMounted(() => {
      const onMoveHandler = (ev: GestureDetail) => {
        if (movingHandler.value || Math.abs(ev.velocityX) <= 1) return
        movingHandler.value = true
        if (ev.deltaX > 0) {
          setCurrentMonthPrev()
        } else if (ev.deltaX < 0) {
          setCurrentMonthNext()
        }
      }
      const el = document.getElementById('calendar-grid-swiper')
      if (!el) return
      const gesture = createGesture({
        el,
        threshold: 40,
        gestureName: 'my-gesture',
        onMove: (ev) => onMoveHandler(ev),
        onEnd: () => (movingHandler.value = false),
      })
      gesture.enable()
    })

    const clickCalendarPage = (date: Dayjs) => {
      props.setModalDate(date)
    }
    return {
      isCurrentMonthToday,
      loading,
      calendarPages,
      clickCalendarPage,
      calendarDateList,
      setCurrentMonthPrev,
      setCurrentMonthCurrent,
      setCurrentMonthNext,
      caretForwardOutline,
      caretBackOutline,
    }
  },
})
</script>

<style lang="scss" scoped>
.calendar-grid-swiper {
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  padding: 0;
}
.row {
  border-bottom: 1px solid #ccc;
  height: calc((100% - 35px) / 6);
  display: grid;
  grid-template-columns: repeat(7, calc(100% / 7));
  &--header {
    height: 34px;
  }
}
.cell {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &:not(:last-child) {
    border-right: 1px solid #ccc;
  }
  &--header {
    background: var(--ion-color-secondary-shade);
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  }
  &--inactive {
    color: rgba(#000, 0.3);
  }
  &-price {
    margin-top: auto;
    text-align: right;
    font-size: 9px;
    white-space: nowrap;
  }
}
.button {
  width: 100%;
  margin-top: 8px;
}
</style>
